<div class="loader-wrapper">
  <div class="loader">
    <div class="loader1">
    </div>
  </div>
  <span class="text-loader">{{'loading' | transloco}}...</span>
</div>
